export default "__VITE_ASSET__DZ_0YU1J__"